export enum ResendCodeError {
  TooManyCodeRequests
}